import type { NewCoreIconProps } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { useMessageContext } from '@atlassian/post-office-context/message-context';
import { type ComponentProps } from 'react';

import { Actions } from './components/actions';
import { HeaderImage } from './components/header-image';
import { type JSX } from 'react/jsx-runtime';

export type Props = {
	bodyContent: React.ReactNode;
	product?:
		| 'Confluence'
		| 'Jira Product Discovery'
		| 'Jira Service Management'
		| 'Rovo Team 25'
		| 'Multi Product Upgrades'
		| 'Rovo Dev Adoption';
	onDismissed?: (messageInstanceId: string) => void;
	whyAmISeeingThisModalContent?: ComponentProps<typeof Actions>['whyAmISeeingThisModalContent'];
	extraAnalyticsAttributes?: Record<string, string>;
	headerImageAltText?: string;
	iconColor?: NewCoreIconProps['color'];
};

const wrapperStyle = css({
	position: 'relative',
	width: '360px',
	minHeight: '300px',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'start',
	gap: token('space.200', '18px'),
	paddingBottom: token('space.150', '12px'),
	backgroundColor: token('color.background.input', '#FFFFFF'),
	zIndex: 0,
	boxSizing: 'border-box',
});

const borderStyle = css({
	borderRadius: token('radius.small', '3px'),
	boxShadow: token(
		'elevation.shadow.overflow',
		'0px 0px 8px 0px rgba(9, 30, 66, 0.16), 0px 0px 1px 0px rgba(9, 30, 66, 0.12)',
	),
});

export const JiraYourWorkMessage = ({
	onDismissed,
	whyAmISeeingThisModalContent,
	bodyContent,
	product,
	iconColor,
}: Props): JSX.Element => {
	const { messageInstanceId } = useMessageContext();
	if (!messageInstanceId) {
		throw new Error('messageInstanceId is required');
	}
	return (
		<div data-testid="jira-your-work-message" css={[wrapperStyle, borderStyle]}>
			<HeaderImage image={product} />
			{bodyContent}
			<Actions
				whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
				onDismissed={() => onDismissed?.(messageInstanceId)}
				iconColor={iconColor}
			/>
		</div>
	);
};
